import { Component, OnInit } from '@angular/core';
import { Usuario } from "../base/vo/usuario";
import { AutenticacaoService } from "../autenticacao/autenticacao.service"

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  //usuario = new Usuario;

  constructor(public autenticacaoService: AutenticacaoService) { }

  ngOnInit() {

    //this.usuarioDados();
  }

  /*usuarioDados() {
    this.usuario = this.autenticacaoService.usuarioLogado;
      
      console.log(this.usuario);
  }*/

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts